import { Theme } from '@mui/material/styles'

export const silosBoxWrapper = {
  display: 'flex',
  flexDirection: 'row',
}

export const attachedSiloBoxWrapper = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
}

export const actionsBoxWrapper = {
  marginLeft: '10px',
  display: 'flex',
  flexDirection: 'row',
}

export const iconBtnStyle = {
  borderRadius: 8,
  '&:hover': {
    color: (theme: Theme) => theme.palette.primary.main,
  },
}

export const deleteModalTypography = {
  color: (theme: Theme) => theme.palette.text.secondary,
  fontSize: '22px',
  fontWeight: 'bold',
  maxWidth: '380px',
}

export const deleteWithWarningBox = {
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'center',
  alignItems: 'center',
}

export const deleteModalWarningTypography = {
  color: (theme: Theme) => theme.palette.error.main,
  fontSize: '22px',
  fontWeight: 'bold',
  maxWidth: '380px',
}
